module.exports = __webpack_public_path__ + "img/jiaoyu_beijingdaxue_suoluetu.d98adb13.png";